/**
 * Анимация загрузки главной страницы
 */
$.fn.mainPageAnimation = function($banner) {
    const $self = $(this);
    const $loader = $self.find('.js-arch-loader');
    const $progressBar = $loader.find('.js-progress');
    const $mainBanner = $self.find('.js-main-banner');
    const $bannerDescription = $self.find('.js-banner-description');
    const $previews = $self.find('.js-banner-previews');

    /**
     * Заполняем прогресс-бар
     */
    const fillProgressBar = () => {
        let progress = 0;
        let intervalId = setInterval(fill, 20);
        function fill() {
            if (progress >= 100) {
                clearInterval(intervalId);
                $progressBar.on('transitionend', () => {
                    $loader.css({'backgroundColor': 'transparent', 'opacity': 0});
                    prepareDOM();
                });
                $loader.on('transitionend', () => {
                    $loader.remove();
                    $banner.init();
                    $('html').removeClass('fixed');
                });
            } else {
                progress++;
                $progressBar.css('width', `${progress}%`)
            }
        }
    };

    /**
     * Готовим DOM для анимации
     */
    const prepareDOM = () => {
        $mainBanner.addClass('animate');
        $self.find('.js-header').addClass('animate');
        $bannerDescription.addClass('animate');
        $previews.addClass('animate');
    };

    /**
     * Инициализация плагина
     */
    const init = () => {
        window.scrollTop = 0;
        $('html').addClass('fixed');
        fillProgressBar();
    };

    init();

};
